import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para carga masiva de dietas
 * Maneja la carga masiva de asignaciones de dieta desde Excel
 *
 * ⚠️ IMPORTANTE: Este servicio usa el backend de PYTHON (Puerto 8003)
 * NO debe usar el backend de PHP/Laravel
 */
export const cargaMasivaDietasApi = {
  /**
   * Procesa la carga masiva de dietas desde archivo Excel
   * El backend procesa el Excel, valida y carga los datos
   * @param {File} file - Archivo Excel (.xlsx, .xls)
   * @param {number} idProyecto - ID del proyecto para asociar las dietas
   * @returns {Promise} - Respuesta de la API con resultados del procesamiento
   */
  procesarCargaMasiva: (file, idProyecto) => {
    // ✅ USA PYTHON: POST http://localhost:8003/api-campamento/procesos/alimentacion/carga-masiva/dietas
    // Envía el archivo Excel directamente al backend usando FormData
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id_proyecto', idProyecto);
    
    return pythonApiClient.post('/procesos/alimentacion/carga-masiva/dietas', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  /**
   * Obtiene información de tipos de dieta para mostrar en la plantilla
   * @returns {Promise} - Respuesta con lista de tipos de dieta disponibles
   */
  obtenerTiposDieta: () => {
    // ✅ USA PYTHON: GET http://localhost:8003/api-campamento/procesos/alimentacion/carga-masiva/dietas/tipos-dieta-info
    return pythonApiClient.get('/procesos/alimentacion/carga-masiva/dietas/tipos-dieta-info');
  }
};

export default cargaMasivaDietasApi;
